/**
 * Created by Anti Asko on 30/6/2015.
 */
import i18n from 'l10n';

var it = {};

var data = [
    {
        "name": "Afghanistan",
        "alpha": "AF",
        "country-code": "004"
    },
    {
        "name": "Åland Islands",
        "alpha": "AX",
        "country-code": "248"
    },
    {
        "name": "Albania",
        "alpha": "AL",
        "country-code": "008"
    },
    {
        "name": "Algeria",
        "alpha": "DZ",
        "country-code": "012"
    },
    {
        "name": "American Samoa",
        "alpha": "AS",
        "country-code": "016"
    },
    {
        "name": "Andorra",
        "alpha": "AD",
        "country-code": "020"
    },
    {
        "name": "Angola",
        "alpha": "AO",
        "country-code": "024"
    },
    {
        "name": "Anguilla",
        "alpha": "AI",
        "country-code": "660"
    },
    {
        "name": "Antarctica",
        "alpha": "AQ",
        "country-code": "010"
    },
    {
        "name": "Antigua and Barbuda",
        "alpha": "AG",
        "country-code": "028"
    },
    {
        "name": "Argentina",
        "alpha": "AR",
        "country-code": "032"
    },
    {
        "name": "Armenia",
        "alpha": "AM",
        "country-code": "051"
    },
    {
        "name": "Aruba",
        "alpha": "AW",
        "country-code": "533"
    },
    {
        "name": "Australia",
        "alpha": "AU",
        "country-code": "036"
    },
    {
        "name": "Austria",
        "alpha": "AT",
        "country-code": "040",
        "taxAlpha": "AT"
    },
    {
        "name": "Azerbaijan",
        "alpha": "AZ",
        "country-code": "031"
    },
    {
        "name": "Bahamas",
        "alpha": "BS",
        "country-code": "044"
    },
    {
        "name": "Bahrain",
        "alpha": "BH",
        "country-code": "048"
    },
    {
        "name": "Bangladesh",
        "alpha": "BD",
        "country-code": "050"
    },
    {
        "name": "Barbados",
        "alpha": "BB",
        "country-code": "052"
    },
    {
        "name": "Belarus",
        "alpha": "BY",
        "country-code": "112"
    },
    {
        "name": "Belgium",
        "alpha": "BE",
        "country-code": "056",
        "taxAlpha": "BE"
    },
    {
        "name": "Belize",
        "alpha": "BZ",
        "country-code": "084"
    },
    {
        "name": "Benin",
        "alpha": "BJ",
        "country-code": "204"
    },
    {
        "name": "Bermuda",
        "alpha": "BM",
        "country-code": "060"
    },
    {
        "name": "Bhutan",
        "alpha": "BT",
        "country-code": "064"
    },
    {
        "name": "Bolivia, Plurinational State of",
        "alpha": "BO",
        "country-code": "068"
    },
    {
        "name": "Bonaire, Sint Eustatius and Saba",
        "alpha": "BQ",
        "country-code": "535"
    },
    {
        "name": "Bosnia and Herzegovina",
        "alpha": "BA",
        "country-code": "070"
    },
    {
        "name": "Botswana",
        "alpha": "BW",
        "country-code": "072"
    },
    {
        "name": "Bouvet Island",
        "alpha": "BV",
        "country-code": "074"
    },
    {
        "name": "Brazil",
        "alpha": "BR",
        "country-code": "076"
    },
    {
        "name": "British Indian Ocean Territory",
        "alpha": "IO",
        "country-code": "086"
    },
    {
        "name": "Brunei Darussalam",
        "alpha": "BN",
        "country-code": "096"
    },
    {
        "name": "Bulgaria",
        "alpha": "BG",
        "country-code": "100",
        "taxAlpha": "BG"

    },
    {
        "name": "Burkina Faso",
        "alpha": "BF",
        "country-code": "854"
    },
    {
        "name": "Burundi",
        "alpha": "BI",
        "country-code": "108"
    },
    {
        "name": "Cambodia",
        "alpha": "KH",
        "country-code": "116"
    },
    {
        "name": "Cameroon",
        "alpha": "CM",
        "country-code": "120"
    },
    {
        "name": "Canada",
        "alpha": "CA",
        "country-code": "124"
    },
    {
        "name": "Cape Verde",
        "alpha": "CV",
        "country-code": "132"
    },
    {
        "name": "Cayman Islands",
        "alpha": "KY",
        "country-code": "136"
    },
    {
        "name": "Central African Republic",
        "alpha": "CF",
        "country-code": "140"
    },
    {
        "name": "Chad",
        "alpha": "TD",
        "country-code": "148"
    },
    {
        "name": "Chile",
        "alpha": "CL",
        "country-code": "152"
    },
    {
        "name": "China",
        "alpha": "CN",
        "country-code": "156"
    },
    {
        "name": "Christmas Island",
        "alpha": "CX",
        "country-code": "162"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "alpha": "CC",
        "country-code": "166"
    },
    {
        "name": "Colombia",
        "alpha": "CO",
        "country-code": "170"
    },
    {
        "name": "Comoros",
        "alpha": "KM",
        "country-code": "174"
    },
    {
        "name": "Congo",
        "alpha": "CG",
        "country-code": "178"
    },
    {
        "name": "Congo, the Democratic Republic of the",
        "alpha": "CD",
        "country-code": "180"
    },
    {
        "name": "Cook Islands",
        "alpha": "CK",
        "country-code": "184"
    },
    {
        "name": "Costa Rica",
        "alpha": "CR",
        "country-code": "188"
    },
    {
        "name": "Côte d'Ivoire",
        "alpha": "CI",
        "country-code": "384"
    },
    {
        "name": "Croatia",
        "alpha": "HR",
        "country-code": "191",
        "taxAlpha": "HR"
    },
    {
        "name": "Cuba",
        "alpha": "CU",
        "country-code": "192"
    },
    {
        "name": "Curaçao",
        "alpha": "CW",
        "country-code": "531"
    },
    {
        "name": "Cyprus",
        "alpha": "CY",
        "country-code": "196",
        "taxAlpha": "CY"
    },
    {
        "name": "Czech Republic",
        "alpha": "CZ",
        "country-code": "203",
        "taxAlpha": "CZ"
    },
    {
        "name": "Denmark",
        "alpha": "DK",
        "country-code": "208",
        "taxAlpha": "DK"
    },
    {
        "name": "Djibouti",
        "alpha": "DJ",
        "country-code": "262"
    },
    {
        "name": "Dominica",
        "alpha": "DM",
        "country-code": "212"
    },
    {
        "name": "Dominican Republic",
        "alpha": "DO",
        "country-code": "214"
    },
    {
        "name": "Ecuador",
        "alpha": "EC",
        "country-code": "218"
    },
    {
        "name": "Egypt",
        "alpha": "EG",
        "country-code": "818"
    },
    {
        "name": "El Salvador",
        "alpha": "SV",
        "country-code": "222"
    },
    {
        "name": "Equatorial Guinea",
        "alpha": "GQ",
        "country-code": "226"
    },
    {
        "name": "Eritrea",
        "alpha": "ER",
        "country-code": "232"
    },
    {
        "name": "Estonia",
        "alpha": "EE",
        "country-code": "233",
        "taxAlpha": "EE"
    },
    {
        "name": "Ethiopia",
        "alpha": "ET",
        "country-code": "231"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "alpha": "FK",
        "country-code": "238"
    },
    {
        "name": "Faroe Islands",
        "alpha": "FO",
        "country-code": "234"
    },
    {
        "name": "Fiji",
        "alpha": "FJ",
        "country-code": "242"
    },
    {
        "name": "Finland",
        "alpha": "FI",
        "country-code": "246",
        "taxAlpha": "FI"
    },
    {
        "name": "France",
        "alpha": "FR",
        "country-code": "250",
        "taxAlpha": "FR"
    },
    {
        "name": "French Guiana",
        "alpha": "GF",
        "country-code": "254"
    },
    {
        "name": "French Polynesia",
        "alpha": "PF",
        "country-code": "258"
    },
    {
        "name": "French Southern Territories",
        "alpha": "TF",
        "country-code": "260"
    },
    {
        "name": "Gabon",
        "alpha": "GA",
        "country-code": "266"
    },
    {
        "name": "Gambia",
        "alpha": "GM",
        "country-code": "270"
    },
    {
        "name": "Georgia",
        "alpha": "GE",
        "country-code": "268"
    },
    {
        "name": "Germany",
        "alpha": "DE",
        "country-code": "276",
        "taxAlpha": "DE"
    },
    {
        "name": "Ghana",
        "alpha": "GH",
        "country-code": "288"
    },
    {
        "name": "Gibraltar",
        "alpha": "GI",
        "country-code": "292"
    },
    {
        "name": "Greece",
        "alpha": "GR",
        "country-code": "300",
        "taxAlpha": "EL"
    },
    {
        "name": "Greenland",
        "alpha": "GL",
        "country-code": "304"
    },
    {
        "name": "Grenada",
        "alpha": "GD",
        "country-code": "308"
    },
    {
        "name": "Guadeloupe",
        "alpha": "GP",
        "country-code": "312"
    },
    {
        "name": "Guam",
        "alpha": "GU",
        "country-code": "316"
    },
    {
        "name": "Guatemala",
        "alpha": "GT",
        "country-code": "320"
    },
    {
        "name": "Guernsey",
        "alpha": "GG",
        "country-code": "831"
    },
    {
        "name": "Guinea",
        "alpha": "GN",
        "country-code": "324"
    },
    {
        "name": "Guinea-Bissau",
        "alpha": "GW",
        "country-code": "624"
    },
    {
        "name": "Guyana",
        "alpha": "GY",
        "country-code": "328"
    },
    {
        "name": "Haiti",
        "alpha": "HT",
        "country-code": "332"
    },
    {
        "name": "Heard Island and McDonald Islands",
        "alpha": "HM",
        "country-code": "334"
    },
    {
        "name": "Holy See (Vatican City State)",
        "alpha": "VA",
        "country-code": "336"
    },
    {
        "name": "Honduras",
        "alpha": "HN",
        "country-code": "340"
    },
    {
        "name": "Hong Kong",
        "alpha": "HK",
        "country-code": "344"
    },
    {
        "name": "Hungary",
        "alpha": "HU",
        "country-code": "348",
        "taxAlpha": "HU"
    },
    {
        "name": "Iceland",
        "alpha": "IS",
        "country-code": "352"
    },
    {
        "name": "India",
        "alpha": "IN",
        "country-code": "356"
    },
    {
        "name": "Indonesia",
        "alpha": "ID",
        "country-code": "360"
    },
    {
        "name": "Iran, Islamic Republic of",
        "alpha": "IR",
        "country-code": "364"
    },
    {
        "name": "Iraq",
        "alpha": "IQ",
        "country-code": "368"
    },
    {
        "name": "Ireland",
        "alpha": "IE",
        "country-code": "372",
        "taxAlpha": "IE"
    },
    {
        "name": "Isle of Man",
        "alpha": "IM",
        "country-code": "833"
    },
    {
        "name": "Israel",
        "alpha": "IL",
        "country-code": "376"
    },
    {
        "name": "Italy",
        "alpha": "IT",
        "country-code": "380",
        "taxAlpha": "IT"
    },
    {
        "name": "Jamaica",
        "alpha": "JM",
        "country-code": "388"
    },
    {
        "name": "Japan",
        "alpha": "JP",
        "country-code": "392"
    },
    {
        "name": "Jersey",
        "alpha": "JE",
        "country-code": "832"
    },
    {
        "name": "Jordan",
        "alpha": "JO",
        "country-code": "400"
    },
    {
        "name": "Kazakhstan",
        "alpha": "KZ",
        "country-code": "398"
    },
    {
        "name": "Kenya",
        "alpha": "KE",
        "country-code": "404"
    },
    {
        "name": "Kiribati",
        "alpha": "KI",
        "country-code": "296"
    },
    {
        "name": "Korea, Democratic People's Republic of",
        "alpha": "KP",
        "country-code": "408"
    },
    {
        "name": "Korea, Republic of",
        "alpha": "KR",
        "country-code": "410"
    },
    {
        "name": "Kuwait",
        "alpha": "KW",
        "country-code": "414"
    },
    {
        "name": "Kyrgyzstan",
        "alpha": "KG",
        "country-code": "417"
    },
    {
        "name": "Lao People's Democratic Republic",
        "alpha": "LA",
        "country-code": "418"
    },
    {
        "name": "Latvia",
        "alpha": "LV",
        "country-code": "428",
        "taxAlpha": "LV"
    },
    {
        "name": "Lebanon",
        "alpha": "LB",
        "country-code": "422"
    },
    {
        "name": "Lesotho",
        "alpha": "LS",
        "country-code": "426"
    },
    {
        "name": "Liberia",
        "alpha": "LR",
        "country-code": "430"
    },
    {
        "name": "Libya",
        "alpha": "LY",
        "country-code": "434"
    },
    {
        "name": "Liechtenstein",
        "alpha": "LI",
        "country-code": "438"
    },
    {
        "name": "Lithuania",
        "alpha": "LT",
        "country-code": "440",
        "taxAlpha": "LT"
    },
    {
        "name": "Luxembourg",
        "alpha": "LU",
        "country-code": "442",
        "taxAlpha": "LU"
    },
    {
        "name": "Macao",
        "alpha": "MO",
        "country-code": "446"
    },
    {
        "name": "Macedonia, the former Yugoslav Republic of",
        "alpha": "MK",
        "country-code": "807"
    },
    {
        "name": "Madagascar",
        "alpha": "MG",
        "country-code": "450"
    },
    {
        "name": "Malawi",
        "alpha": "MW",
        "country-code": "454"
    },
    {
        "name": "Malaysia",
        "alpha": "MY",
        "country-code": "458"
    },
    {
        "name": "Maldives",
        "alpha": "MV",
        "country-code": "462"
    },
    {
        "name": "Mali",
        "alpha": "ML",
        "country-code": "466"
    },
    {
        "name": "Malta",
        "alpha": "MT",
        "country-code": "470",
        "taxAlpha": "MT"
    },
    {
        "name": "Marshall Islands",
        "alpha": "MH",
        "country-code": "584"
    },
    {
        "name": "Martinique",
        "alpha": "MQ",
        "country-code": "474"
    },
    {
        "name": "Mauritania",
        "alpha": "MR",
        "country-code": "478"
    },
    {
        "name": "Mauritius",
        "alpha": "MU",
        "country-code": "480"
    },
    {
        "name": "Mayotte",
        "alpha": "YT",
        "country-code": "175"
    },
    {
        "name": "Mexico",
        "alpha": "MX",
        "country-code": "484"
    },
    {
        "name": "Micronesia, Federated States of",
        "alpha": "FM",
        "country-code": "583"
    },
    {
        "name": "Moldova, Republic of",
        "alpha": "MD",
        "country-code": "498"
    },
    {
        "name": "Monaco",
        "alpha": "MC",
        "country-code": "492"
    },
    {
        "name": "Mongolia",
        "alpha": "MN",
        "country-code": "496"
    },
    {
        "name": "Montenegro",
        "alpha": "ME",
        "country-code": "499"
    },
    {
        "name": "Montserrat",
        "alpha": "MS",
        "country-code": "500"
    },
    {
        "name": "Morocco",
        "alpha": "MA",
        "country-code": "504"
    },
    {
        "name": "Mozambique",
        "alpha": "MZ",
        "country-code": "508"
    },
    {
        "name": "Myanmar",
        "alpha": "MM",
        "country-code": "104"
    },
    {
        "name": "Namibia",
        "alpha": "NA",
        "country-code": "516"
    },
    {
        "name": "Nauru",
        "alpha": "NR",
        "country-code": "520"
    },
    {
        "name": "Nepal",
        "alpha": "NP",
        "country-code": "524"
    },
    {
        "name": "Netherlands",
        "alpha": "NL",
        "country-code": "528",
        "taxAlpha": "NL"
    },
    {
        "name": "New Caledonia",
        "alpha": "NC",
        "country-code": "540"
    },
    {
        "name": "New Zealand",
        "alpha": "NZ",
        "country-code": "554"
    },
    {
        "name": "Nicaragua",
        "alpha": "NI",
        "country-code": "558"
    },
    {
        "name": "Niger",
        "alpha": "NE",
        "country-code": "562"
    },
    {
        "name": "Nigeria",
        "alpha": "NG",
        "country-code": "566"
    },
    {
        "name": "Niue",
        "alpha": "NU",
        "country-code": "570"
    },
    {
        "name": "Norfolk Island",
        "alpha": "NF",
        "country-code": "574"
    },
    {
        "name": "Northern Mariana Islands",
        "alpha": "MP",
        "country-code": "580"
    },
    {
        "name": "Norway",
        "alpha": "NO",
        "country-code": "578"
    },
    {
        "name": "Oman",
        "alpha": "OM",
        "country-code": "512"
    },
    {
        "name": "Pakistan",
        "alpha": "PK",
        "country-code": "586"
    },
    {
        "name": "Palau",
        "alpha": "PW",
        "country-code": "585"
    },
    {
        "name": "Palestine, State of",
        "alpha": "PS",
        "country-code": "275"
    },
    {
        "name": "Panama",
        "alpha": "PA",
        "country-code": "591"
    },
    {
        "name": "Papua New Guinea",
        "alpha": "PG",
        "country-code": "598"
    },
    {
        "name": "Paraguay",
        "alpha": "PY",
        "country-code": "600"
    },
    {
        "name": "Peru",
        "alpha": "PE",
        "country-code": "604"
    },
    {
        "name": "Philippines",
        "alpha": "PH",
        "country-code": "608"
    },
    {
        "name": "Pitcairn",
        "alpha": "PN",
        "country-code": "612"
    },
    {
        "name": "Poland",
        "alpha": "PL",
        "country-code": "616",
        "taxAlpha": "PL"
    },
    {
        "name": "Portugal",
        "alpha": "PT",
        "country-code": "620",
        "taxAlpha": "PT"
    },
    {
        "name": "Puerto Rico",
        "alpha": "PR",
        "country-code": "630"
    },
    {
        "name": "Qatar",
        "alpha": "QA",
        "country-code": "634"
    },
    {
        "name": "Réunion",
        "alpha": "RE",
        "country-code": "638"
    },
    {
        "name": "Romania",
        "alpha": "RO",
        "country-code": "642",
        "taxAlpha": "RO"
    },
    {
        "name": "Russian Federation",
        "alpha": "RU",
        "country-code": "643"
    },
    {
        "name": "Rwanda",
        "alpha": "RW",
        "country-code": "646"
    },
    {
        "name": "Saint Barthélemy",
        "alpha": "BL",
        "country-code": "652"
    },
    {
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "alpha": "SH",
        "country-code": "654"
    },
    {
        "name": "Saint Kitts and Nevis",
        "alpha": "KN",
        "country-code": "659"
    },
    {
        "name": "Saint Lucia",
        "alpha": "LC",
        "country-code": "662"
    },
    {
        "name": "Saint Martin (French part)",
        "alpha": "MF",
        "country-code": "663"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "alpha": "PM",
        "country-code": "666"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "alpha": "VC",
        "country-code": "670"
    },
    {
        "name": "Samoa",
        "alpha": "WS",
        "country-code": "882"
    },
    {
        "name": "San Marino",
        "alpha": "SM",
        "country-code": "674"
    },
    {
        "name": "Sao Tome and Principe",
        "alpha": "ST",
        "country-code": "678"
    },
    {
        "name": "Saudi Arabia",
        "alpha": "SA",
        "country-code": "682"
    },
    {
        "name": "Senegal",
        "alpha": "SN",
        "country-code": "686"
    },
    {
        "name": "Serbia",
        "alpha": "RS",
        "country-code": "688"
    },
    {
        "name": "Seychelles",
        "alpha": "SC",
        "country-code": "690"
    },
    {
        "name": "Sierra Leone",
        "alpha": "SL",
        "country-code": "694"
    },
    {
        "name": "Singapore",
        "alpha": "SG",
        "country-code": "702"
    },
    {
        "name": "Sint Maarten (Dutch part)",
        "alpha": "SX",
        "country-code": "534"
    },
    {
        "name": "Slovakia",
        "alpha": "SK",
        "country-code": "703",
        "taxAlpha": "SK"
    },
    {
        "name": "Slovenia",
        "alpha": "SI",
        "country-code": "705",
        "taxAlpha": "SI"
    },
    {
        "name": "Solomon Islands",
        "alpha": "SB",
        "country-code": "090"
    },
    {
        "name": "Somalia",
        "alpha": "SO",
        "country-code": "706"
    },
    {
        "name": "South Africa",
        "alpha": "ZA",
        "country-code": "710"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "alpha": "GS",
        "country-code": "239"
    },
    {
        "name": "South Sudan",
        "alpha": "SS",
        "country-code": "728"
    },
    {
        "name": "Spain",
        "alpha": "ES",
        "country-code": "724",
        "taxAlpha": "ES"
    },
    {
        "name": "Sri Lanka",
        "alpha": "LK",
        "country-code": "144"
    },
    {
        "name": "Sudan",
        "alpha": "SD",
        "country-code": "729"
    },
    {
        "name": "Suriname",
        "alpha": "SR",
        "country-code": "740"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "alpha": "SJ",
        "country-code": "744"
    },
    {
        "name": "Swaziland",
        "alpha": "SZ",
        "country-code": "748"
    },
    {
        "name": "Sweden",
        "alpha": "SE",
        "country-code": "752",
        "taxAlpha": "SE"
    },
    {
        "name": "Switzerland",
        "alpha": "CH",
        "country-code": "756"
    },
    {
        "name": "Syrian Arab Republic",
        "alpha": "SY",
        "country-code": "760"
    },
    {
        "name": "Taiwan, Province of China",
        "alpha": "TW",
        "country-code": "158"
    },
    {
        "name": "Tajikistan",
        "alpha": "TJ",
        "country-code": "762"
    },
    {
        "name": "Tanzania, United Republic of",
        "alpha": "TZ",
        "country-code": "834"
    },
    {
        "name": "Thailand",
        "alpha": "TH",
        "country-code": "764"
    },
    {
        "name": "Timor-Leste",
        "alpha": "TL",
        "country-code": "626"
    },
    {
        "name": "Togo",
        "alpha": "TG",
        "country-code": "768"
    },
    {
        "name": "Tokelau",
        "alpha": "TK",
        "country-code": "772"
    },
    {
        "name": "Tonga",
        "alpha": "TO",
        "country-code": "776"
    },
    {
        "name": "Trinidad and Tobago",
        "alpha": "TT",
        "country-code": "780"
    },
    {
        "name": "Tunisia",
        "alpha": "TN",
        "country-code": "788"
    },
    {
        "name": "Turkey",
        "alpha": "TR",
        "country-code": "792"
    },
    {
        "name": "Turkmenistan",
        "alpha": "TM",
        "country-code": "795"
    },
    {
        "name": "Turks and Caicos Islands",
        "alpha": "TC",
        "country-code": "796"
    },
    {
        "name": "Tuvalu",
        "alpha": "TV",
        "country-code": "798"
    },
    {
        "name": "Uganda",
        "alpha": "UG",
        "country-code": "800"
    },
    {
        "name": "Ukraine",
        "alpha": "UA",
        "country-code": "804"
    },
    {
        "name": "United Arab Emirates",
        "alpha": "AE",
        "country-code": "784"
    },
    {
        "name": "United Kingdom",
        "alpha": "GB",
        "country-code": "826",
        "taxAlpha": "GB"
    },
    {
        "name": "United States",
        "alpha": "US",
        "country-code": "840"
    },
    {
        "name": "United States Minor Outlying Islands",
        "alpha": "UM",
        "country-code": "581"
    },
    {
        "name": "Uruguay",
        "alpha": "UY",
        "country-code": "858"
    },
    {
        "name": "Uzbekistan",
        "alpha": "UZ",
        "country-code": "860"
    },
    {
        "name": "Vanuatu",
        "alpha": "VU",
        "country-code": "548"
    },
    {
        "name": "Venezuela, Bolivarian Republic of",
        "alpha": "VE",
        "country-code": "862"
    },
    {
        "name": "Viet Nam",
        "alpha": "VN",
        "country-code": "704"
    },
    {
        "name": "Virgin Islands, British",
        "alpha": "VG",
        "country-code": "092"
    },
    {
        "name": "Virgin Islands, U.S.",
        "alpha": "VI",
        "country-code": "850"
    },
    {
        "name": "Wallis and Futuna",
        "alpha": "WF",
        "country-code": "876"
    },
    {
        "name": "Western Sahara",
        "alpha": "EH",
        "country-code": "732"
    },
    {
        "name": "Yemen",
        "alpha": "YE",
        "country-code": "887"
    },
    {
        "name": "Zambia",
        "alpha": "ZM",
        "country-code": "894"
    },
    {
        "name": "Zimbabwe",
        "alpha": "ZW",
        "country-code": "716"
    }
]

var findAlphaFromCountry = function (name) {
    var alpha;
    data.forEach(function (elem) {
        if (elem.name == name) {
            alpha = elem.alpha;
        }

    });
    return alpha;

};

var findCountryFromAlpha = function (alpha) {
//        var country;
//            data.forEach(function(elem) {
//                if(elem.alpha == alpha) {
//                    country = elem.name;
//                }
//            });
//        return country;
    return i18n.findCountryFromCode(alpha);
};

var findTaxAlphaFromCountryCode = function (code) {
    var taxAlpha;
    data.forEach(function (elem) {
        if (elem.alpha == code) {
            taxAlpha = elem.taxAlpha;
        }
    });
    return taxAlpha;
};

var getCountryNames = function () {
    return i18n.getCountries();
};

it.countryNameToAlpha = function (name) {
    return findAlphaFromCountry(name);
};

it.alphaToCountry = function (alpha) {
    return findCountryFromAlpha(alpha);
};

it.getCountries = function () {
    return getCountryNames();
};

it.countryCodeToTaxAlpha = function (code) {
    return findTaxAlphaFromCountryCode(code);
};

export default it;